export type ButtonVariant = "primary" | "secondary" | "tertiary" | "ghost" | "danger" | "success";
export type ButtonSize = "sm" | "md" | "lg";

// SVG spinner para evitar emoji ou dependências externas
const SPINNER_SVG = `<svg class="spinner" aria-hidden="true" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-opacity="0.25" stroke-width="3"/>
  <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
</svg>`;

export class AppButton extends HTMLElement {
  static get observedAttributes() {
    return ["variant", "size", "disabled", "loading", "type"];
  }

  connectedCallback() { this.render(); }
  attributeChangedCallback() { this.render(); }

  private render() {
    const attrVariant = this.getAttribute("variant");
    const variant: ButtonVariant =
      attrVariant === "secondary" || attrVariant === "tertiary" ||
      attrVariant === "ghost" || attrVariant === "danger" || attrVariant === "success"
        ? attrVariant : "primary";

    const attrSize = this.getAttribute("size");
    const size: ButtonSize = attrSize === "sm" || attrSize === "lg" ? attrSize : "md";

    const disabled = this.hasAttribute("disabled");
    const loading = this.hasAttribute("loading");
    const type = (this.getAttribute("type") || "button") as "button" | "submit" | "reset";

    // Preservar conteúdo interno antes de re-renderizar
    const existingButton = this.querySelector("button");
    if (existingButton) {
      existingButton.className = `btn btn-${variant} btn-${size}`;
      existingButton.disabled = disabled || loading;
      existingButton.type = type;
      if (loading) {
        existingButton.setAttribute("aria-busy", "true");
      } else {
        existingButton.removeAttribute("aria-busy");
      }
      return;
    }

    const content = this.innerHTML;

    this.innerHTML = `
      <button
        type="${type}"
        class="btn btn-${variant} btn-${size}"
        ${disabled || loading ? "disabled" : ""}
        ${loading ? 'aria-busy="true"' : ""}
      >
        ${loading ? SPINNER_SVG : ""}
        <span>${content}</span>
      </button>
    `;
  }
}

if (!customElements.get("app-button")) {
  customElements.define("app-button", AppButton);
}
